import { BaseService } from '../../infra/base.service'
import type { SearchItem } from '../search-items/search-items'
import type { CreateStaticAudienceDto } from './create-static-audience.dto'
import type { SearchQueryRepository } from './search-query.repository'

export class SearchQueryService extends BaseService<SearchItem> {
    constructor(private rep: SearchQueryRepository) {
        super(rep)
    }

    async getCities() {
        return await this.rep.getCities()
    }

    async getCategories() {
        return await this.rep.getCategories()
    }

    async add(dto: CreateStaticAudienceDto) {
        return await this.rep.add(dto)
    }
}
